module.exports = __webpack_public_path__ + "public/Icons/cancel_reason.svg?9c11abc3";